module.exports = __webpack_public_path__ + "img/aov_banner.9fd760ce.jpg";